import { all, call, cancel, fork, put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { rsf } from '../globals/firebase';
import api from '../services/api/ef/api';
// import {IUserOrGroup} from '../Interfaces/Users.inteface'
import * as channelsRoutines from '../Containers/Channels/channelRoutines';
import * as ls from '../services/localStorage';
import * as paths from '../Providers/paths';
import * as rootSelectors from '../selectors/root';
import * as userRoutines from './routines/userRoutines';
import { makePoolId } from '../Containers/Events/selectors';
import { makeSelectedGroupUsers } from '../redux/usersSelectors';
import { selectInvitees } from '../redux/usersSelectors';
import distinctUsers from '../helpers/distinctUsers';
import * as _ from 'lodash'
export function* resetUserSync() {
    yield put(userRoutines.stopSyncingUsers.trigger());
    yield put(userRoutines.syncUsers());
}

function getUserInfoToPushForUser(attributesToPush, rawInviteeData){
    const res = {}
    const questionResponses = _.get(rawInviteeData, ['relationships', 'questionResponses'], [])
    const attributes = _.get(rawInviteeData, ['relationships', 'user', 'relationships', 'userAttributes'], [])

    questionResponses.forEach(qr =>{
        if(!res['responses']) res['responses'] = {}
        const question = _.get(qr, 'relationships.question', null)
        const answerText = _.get(qr, 'attributes.text', '')
        const answer = _.get(qr, 'relationships.answer', null)
        //Create placeholder for answers if it doesn't exist
        if(!res['responses'][_.get(question, 'id')]){
            res['responses'][_.get(question, 'id')] = {}
        }
        if(!res['responses'][_.get(question, 'id')]['answers']){
            res['responses'][_.get(question, 'id')]['answers'] = {}
        }
        res['responses'][question.id]['answers'][_.get(qr, 'id')] =  {
            answerId: _.get(answer, 'id', ''),
            text: answerText ? answerText : _.get(answer, 'attributes.text', '')
        }
    })

    attributes.forEach(attribute =>{
        const name = _.get(attribute, 'attributes.value.key')

        const value = _.get(attribute, 'attributes.value.value')
        //If attribute is marked as one to push, and a value exists
        if(attributesToPush[name] && value !== ''){
            res[name] = value
        }
    })

    //Email
    res['email'] = _.get(rawInviteeData, 'attributes.email')
    return res
}
//This is used to populate reg question answers in Firebase
export function* updateUserInfoSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    let userInfoToPush = {};
    let attributesToPush = {company:true, telephone: true, position: true, other:true}
        //We need to obtain key/value pairs of userId/name
        const inviteesRaw = yield select(selectInvitees);
        Object.keys(inviteesRaw).map(k =>{
            userInfoToPush[k] =  getUserInfoToPushForUser(attributesToPush, inviteesRaw[k])
            return true
        })

    try {
        yield call(rsf.database.patch, paths.moduleData(activeEvent, 'userInfo'), userInfoToPush);
        yield put(userRoutines.updateUserInfo.success());
    } catch (error) {
        yield put(userRoutines.updateUserInfo.failure(error));
    }
}

export function* updateActiveUsersSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    let usersToPush = {};
        //We need to obtain key/value pairs of userId/name
        const inviteesRaw = yield select(selectInvitees);
        Object.keys(inviteesRaw).map(k =>{
            const target = _.get(inviteesRaw, [k, 'attributes', 'userName', 'fullName'], '')
            usersToPush[k] = target
            return true;
        })

    try {
        yield call(rsf.database.patch, paths.moduleData(activeEvent, 'activeUsers'), usersToPush);
        yield put(userRoutines.updateActiveUsers.success());
    } catch (error) {
        yield put(userRoutines.updateActiveUsers.failure(error));
    }
}

export function* syncUsersSaga() {
    //Synces active users from FB
    const activeEvent = yield select(rootSelectors.selectActiveEventId);

    yield fork(rsf.database.sync, paths.moduleData(activeEvent, 'activeUsers'), {
        successActionCreator: userRoutines.syncUsers.success,
        failureActionCreator: userRoutines.syncUsers.failure,
    });
}

export function* syncUserInfoSaga() {
    //Synces active users from FB
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleData(activeEvent, 'userInfo'), {
        successActionCreator: userRoutines.syncUserInfo.success,
        failureActionCreator: userRoutines.syncUserInfo.failure,
    });
}


export function* fetchGroups() {
    try {
        let res = yield call(api.listGroups, ls.getCCValues().CC_USER_ID);
        let groups = res.data.data;
        yield put(channelsRoutines.fetchGroups.success(groups));
    } catch (error) {
        yield put(channelsRoutines.fetchGroups.failure(error));
    }
}
function* processUsersBatchFromGroup(payload) {
    const { groupId, itemsPerPage, page } = payload;
    const poolId = yield select(makePoolId);
    try {
        //Fetch specific batch/page of invitees
        let batch = yield call(api.listUsersInGroup, groupId, poolId, page, itemsPerPage);
        yield put(channelsRoutines.fetchUsersBatchFromGroup.success({ groupId: groupId, users: batch.data.data }));
    } catch (error) {
        yield put(channelsRoutines.fetchUsersBatchFromGroup.error(error));
    }
}

export function* fetchUsersFromGroup(action) {
    //Fetches users from an EF group
    try {
        const poolId = yield select(makePoolId);
        //Obtain meta information
        let res = yield call(api.listUsersInGroup, action.payload, poolId, 1, 75);
        const { itemsPerPage, totalPages } = res.data.meta;
        yield all(
            [...Array(totalPages)].map((val, idx) => {
                let page = idx + 1;
                return call(processUsersBatchFromGroup, {
                    groupId: action.payload,
                    itemsPerPage,
                    page,
                });
            }),
        );
        yield put(channelsRoutines.fetchUsersFromGroup.success());
    } catch (error) {
        yield put(channelsRoutines.fetchUsersFromGroup.failure(error));
    }
}
//Expects an array of objects in the form {id:"string", name:"string", type:"string"}
export function* makeDistinctUsersFromCombinedSaga(action) {
    const activeUsers = yield select(rootSelectors.selectUsers);
    try {
        yield put(userRoutines.loadingUsers.trigger(true));
        //Array of groups
        const groups = action.payload.filter(obj => obj.type === 'group'); //TODO We should be able to do this in one call
        const users = action.payload.filter(obj => obj.type !== 'group');

        yield all(
            groups.map(group => {
                return call(fetchUsersFromGroup, { payload: group.id });
            }),
        );

        const usersFromGroups = yield select(makeSelectedGroupUsers);
        let distinct = distinctUsers([...users, ...usersFromGroups]);
        //Only return those users that are also in the active users list
        distinct = activeUsers ? distinct.filter(user => user.id in activeUsers) : [];
        yield put(userRoutines.makeDistinctUsersFromCombined.success(distinct));
        yield put(userRoutines.loadingUsers.trigger(false));
        return distinct;
    } catch (error) {
        yield put(userRoutines.loadingUsers.trigger(false));
        yield put(userRoutines.makeDistinctUsersFromCombined.failure(error));
    }
}

export function* fetchUserAvatarSaga(action) {
    //Fetches user info from top node

    try {
        let avatar = yield call(rsf.database.read, paths.user_from_top(action.payload));
        yield put(userRoutines.fetchUserAvatar.success({ id: action.payload, avatar: avatar.profileImageThumbnail }));
    } catch (error) {
        yield put(userRoutines.fetchUserAvatar.failure(error));
    }
}

export default function* rootUsersWatcher() {
    yield takeEvery(userRoutines.fetchUsersFromGroup.TRIGGER, fetchUsersFromGroup);
    yield takeEvery(userRoutines.makeDistinctUsersFromCombined.TRIGGER, makeDistinctUsersFromCombinedSaga);
    yield takeLatest(userRoutines.fetchUserAvatar.TRIGGER, fetchUserAvatarSaga);
    yield takeLatest(userRoutines.updateActiveUsers.TRIGGER, updateActiveUsersSaga);
    yield takeLatest(userRoutines.updateUserInfo.TRIGGER, updateUserInfoSaga);

    while (yield take(userRoutines.syncUsers.TRIGGER)) {
        const bgUsersSync = yield fork(syncUsersSaga);
        yield take(userRoutines.stopSyncingUsers.TRIGGER);
        yield cancel(bgUsersSync);
    }
}
